// eslint-disable-next-line aloft/prefer-sound-ui-box
import { createCheckBoxFieldNode } from '../createCheckBoxFieldNode.ts';

// Disables all auto adjustments for the Sales Comp grid
export const createAutoAdjustmentsSalesCompUadNode = (doc: XMLDocument): HTMLElement => {
  const autoAdjustment = doc.createElement('Form');
  autoAdjustment.setAttribute('Id', 'AutomaticAdjustments-SalesComps-UAD');

  const fields = doc.createElement('Fields');
  autoAdjustment.append(fields);
  const additional = {
    CompType: 'SalesComparables',
  };

  const fieldNodes = [];

  // Adjustment
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'SiteAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'DesignStyleAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'PorchPatioDeckAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'BlankAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'Blank2AutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'Blank3AutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );

  // Market Conditions
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'MarketConditionsPercentageRateAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'MarketConditionsFlatRateAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'ListSellRatioAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );

  // Above Grade
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'RoomCountBedroomsAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'RoomCountFullBathroomsAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'RoomCountHalfBathroomsAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'GrossLivingAreaAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );

  // Below Grade
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'FoundationBasementTotalAreaAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'FoundationBasementFinishedAreaAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'FoundationBasementAccessAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'RoomsBelowGradeCountRecRoomsAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'RoomsBelowGradeCountBedroomsAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'RoomsBelowGradeCountFullBathroomsAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'RoomsBelowGradeCountHalfBathroomsAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'RoomsBelowGradeCountOtherAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );

  // Car Storage
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'CarStorageAttachedAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'CarStorageDetachedAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'CarStorageBuiltInAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'CarStorageCarportAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'CarStorageDrivewayAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'CarStorageGarageAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'CarStorageCoveredAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );
  fieldNodes.push(
    createCheckBoxFieldNode(doc, {
      Id: 'CarStorageOpenAutoAdjustmentOnCheckBox',
      Data: false,
      additional,
    }),
  );

  fields.append(...fieldNodes);

  return autoAdjustment;
};
